import { render, staticRenderFns } from "./Ppkasosiasi.vue?vue&type=template&id=1c96e39b"
import script from "./Ppkasosiasi.vue?vue&type=script&lang=js"
export * from "./Ppkasosiasi.vue?vue&type=script&lang=js"
import style0 from "./Ppkasosiasi.vue?vue&type=style&index=0&id=1c96e39b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports